module.exports = __webpack_public_path__ + "static/img/gq.beee151.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/gq.jpg
// module id = 1411
// module chunks = 0